import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9cf0920a"
import script from "./addtaxRegimeAccount.js?vue&type=script&lang=js&external"
export * from "./addtaxRegimeAccount.js?vue&type=script&lang=js&external"
import style0 from "./addtaxRegimeAccount.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports